import styled from 'styled-components';
import { Card, Text } from '../design-system';
import { Theme } from '../theme';

const red = Theme.colors.danger;

export const ExpiredCard = styled(Card)<{ expired?: any }>`
  border: ${(p) => p.expired && `1.5px solid ${red}`};
`;

export const ExpiredText = styled(Text)<{ expired?: any }>`
  color: ${(p) => p.expired && red};
`;

export const TableCellExpiredText = styled(Text)`
  border-radius: 15px;
  padding: 5px;
  background-color: ${red};
  color: white;
`;
